import { PROJECT_SESSION_PRELOAD_FRESHNESS_MS } from '#pplx/frontend/apps/ask/hooks/collections-hooks/collectionThreadsQueryOptions.js';
import { getSpacePinnedThreadsQueryKey, getSpaceScheduledThreadsQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/spacesKeys.js';
import { listSpacePinnedThreads } from '#pplx/frontend/apps/ask/queries/spaces-queries/listSpacePinnedThreads.js';
import { listSpaceScheduledThreads } from '#pplx/frontend/apps/ask/queries/spaces-queries/listSpaceScheduledThreads.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
const PRELOAD_REASON = 'sidebar-pinned-project-sessions-preload';
/**
 * Warms the REST-owned pinned and scheduled session lists only. The main list
 * is GraphQL-served, so prefetching its REST rows would issue a
 * list_collection_threads call whose result the page renders at most as
 * transitional placeholder data.
 */
export function usePrefetchProjectSessions({ spaceUuid }) {
    const queryClient = useQueryClient();
    return useCallback(() => {
        if (!spaceUuid)
            return;
        queryClient.prefetchQuery({
            queryKey: getSpacePinnedThreadsQueryKey({ spaceUuid }),
            queryFn: () => listSpacePinnedThreads({
                spaceUuid,
                reason: PRELOAD_REASON,
                throwOnError: true,
            }),
            staleTime: PROJECT_SESSION_PRELOAD_FRESHNESS_MS,
        });
        queryClient.prefetchQuery({
            queryKey: getSpaceScheduledThreadsQueryKey({ spaceUuid }),
            queryFn: () => listSpaceScheduledThreads({
                spaceUuid,
                reason: PRELOAD_REASON,
                throwOnError: true,
            }),
            staleTime: PROJECT_SESSION_PRELOAD_FRESHNESS_MS,
        });
    }, [queryClient, spaceUuid]);
}
//# sourceMappingURL=usePrefetchProjectSessions.js.map